import KeyMirror from 'keymirror';

const CategoryType = KeyMirror({
	GET_ALL_CATEGORY: null,
	GET_LIST_CATEGORY: null,
	GET_LIST_CATEGORY_BY_TOPIC: null,
	CREATE_CATEGORY: null,
	UPDATE_CATEGORY: null,
	HIDE_CATEGORY: null,
	DELETE_CATEGORY: null,
	CLEAR_CATEGORY: null,
});

export default CategoryType;
